// extracted by mini-css-extract-plugin
export default {"downloadLinks":"DownloadLinks_downloadLinks__hsGia"};